import { useEffect, useRef } from 'react';
let scrollLocks = 0;
let previousBodyOverflow = '';
export default function useUploadDialog(open, onDismiss) {
  const ref = useRef(null);
  const dismiss = useRef(onDismiss);
  dismiss.current = onDismiss;
  useEffect(() => {
    if (!open || !ref.current) return;
    const dialog = ref.current;
    const previous = document.activeElement;
    if (scrollLocks++ === 0) {
      previousBodyOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
    }
    const focusable = () => [...dialog.querySelectorAll('button:not(:disabled),a[href],input:not(:disabled),select:not(:disabled),summary,[tabindex="0"]')].filter(el => el.getClientRects().length);
    (focusable()[0] || dialog).focus();
    const keydown = e => {
      // Only the innermost open dialog owns Escape and focus wrapping.
      if (dialog.querySelector('[role="dialog"][aria-modal="true"]')) return;
      if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); dismiss.current(); }
      if (e.key !== 'Tab') return;
      const items = focusable(); const first=items[0], last=items[items.length-1];
      if (!first) { e.preventDefault(); dialog.focus(); }
      else if (e.shiftKey && (document.activeElement===first || !dialog.contains(document.activeElement))) {e.preventDefault();last.focus();}
      else if (!e.shiftKey && (document.activeElement===last || !dialog.contains(document.activeElement))) {e.preventDefault();first.focus();}
    };
    document.addEventListener('keydown',keydown,true);
    return () => {document.removeEventListener('keydown',keydown,true);if (--scrollLocks === 0) document.body.style.overflow=previousBodyOverflow;if(previous?.isConnected)previous.focus();};
  },[open]);
  return ref;
}
